import React from "react";

const QuotationDesktopStyles = () => (
    <style>
        {`
            @media (min-width: 1024px) {
                .quotation-desktop-surface {
                    min-height: 100%;
                    background: linear-gradient(to right, #FFF0E4, #E4E7FF);
                    color: #303026;
                }

                .quotation-desktop-surface .sticky.top-0.bg-white,
                .quotation-desktop-surface .lg\\:sticky.lg\\:top-0.bg-white {
                    border: 0;
                    border-radius: 0;
                    box-shadow: 0 8px 22px rgba(48, 48, 38, 0.08);
                }

                .quotation-desktop-surface .rfq-information-card,
                .quotation-desktop-surface .bg-white.shadow-md,
                .quotation-desktop-surface .shadow-md.bg-white {
                    border: 1px solid #E7E7DD;
                    border-radius: 18px;
                    box-shadow: 0 14px 34px rgba(48, 48, 38, 0.08);
                    overflow: hidden;
                }

                .quotation-desktop-surface .rfq-information-grid {
                    background: #FFFFFF;
                }

                .quotation-desktop-surface .rfq-information-grid > div {
                    min-height: auto;
                }

                .quotation-desktop-surface .rfq-information-grid p,
                .quotation-desktop-surface .rfq-information-grid span {
                    line-height: 1.45;
                }

                .quotation-desktop-surface .rfq-information-grid .text-\\[\\#6B7280\\],
                .quotation-desktop-surface .rfq-information-grid [class*="text-[#6B7280]"] {
                    color: #7A7A68;
                }

                .quotation-desktop-surface .rfq-information-grid .font-bold {
                    color: #303026;
                }

                .quotation-desktop-surface h3 {
                    color: #303026;
                    letter-spacing: 0.01em;
                }

                .quotation-desktop-surface hr {
                    border-color: #DCDCD0;
                }

                .quotation-desktop-surface .border-y {
                    border-color: #E7E7DD;
                    border-radius: 0;
                    background: #FBFBF7;
                    padding-left: 12px;
                    padding-right: 12px;
                }

                .quotation-desktop-surface input[type="text"],
                .quotation-desktop-surface textarea {
                    border-color: #DCDCD0;
                    border-radius: 0;
                    background: #FFFFFF;
                }

                .quotation-desktop-surface input[type="text"]:focus,
                .quotation-desktop-surface textarea:focus {
                    border-color: #004491;
                    box-shadow: 0 0 0 2px rgba(0, 68, 145, 0.08);
                }

                .quotation-desktop-surface input:disabled,
                .quotation-desktop-surface textarea:disabled {
                    background: #F3F4F6;
                    color: #6B7280;
                }

                .quotation-desktop-surface .bg-gray-200 {
                    border: 1px solid #D8E4FF;
                    border-radius: 0;
                    background: #F8FAFF !important;
                }

                .quotation-desktop-surface .border-2.bg-white {
                    border: 1px solid #E7E7DD;
                    border-top: 0;
                    border-radius: 0 0 16px 16px;
                    
                }

                .quotation-desktop-surface .bg-blue-500 {
                    border-radius: 0;
                    background: #004491 !important;
                    box-shadow: 0 8px 16px rgba(0, 68, 145, 0.16);
                }

                .quotation-desktop-surface label.border.border-gray-800 {
                    border-color: #1E1E08;
                    border-radius: 0;
                    background: #FFFFFF;
                }

                .quotation-desktop-surface .border-dashed {
                    border-color: #004491 !important;
                    border-radius: 18px;
                    background: #F8FAFF !important;
                }

                .quotation-desktop-surface [class*="bg-[#E0F0EE]"] {
                    background: transparent !important;
                }

                .quotation-desktop-surface .additional-cost-card [class*="lg:grid"] {
                    padding-left: 12px;
                    padding-right: 12px;
                }

                .quotation-desktop-surface .additional-cost-card [class*="lg:grid"]:not(.border-y) {
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #F0F0E8;
                }

                .quotation-desktop-surface .additional-cost-card [class*="lg:grid"]:last-child {
                    border-bottom: 0;
                }

                .quotation-desktop-surface .additional-cost-card input[type="text"],
                .quotation-desktop-surface .additional-cost-card textarea,
                .quotation-desktop-surface .additional-cost-card .ql-container {
                    border-radius: 0 !important;
                }

                .quotation-desktop-surface .desktop-material-list {
                    margin-top: 8px;
                    padding-top: 8px;
                }

                .quotation-desktop-surface .desktop-material-list hr {
                    margin-top: 6px;
                }

                .quotation-desktop-surface .desktop-material-row {
                    padding-top: 2px;
                    padding-bottom: 2px;
                }

                .quotation-desktop-surface .desktop-labour-item {
                    border-bottom: 1px solid #E7E7DD;
                    padding-bottom: 12px;
                }

                .quotation-desktop-surface .desktop-labour-item:last-child {
                    border-bottom: 0;
                    padding-bottom: 0;
                }

                .quotation-desktop-surface .providing-material-scope-header {
                    background: #FCFCFA;
                    border: 1px solid #E7E7DD;
                    padding: 8px 12px;
                }
            }
        `}
    </style>
);

export default QuotationDesktopStyles;
